import React from 'react';
import { Box, H3, Typography, spacing, colors } from '@procore/core-react';
import PT from 'prop-types';
import styled from 'styled-components';
import { marketplaceColors } from '@/react/styles/constants';

const Title = styled(H3)`
  color: ${colors.black};
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  margin-bottom: ${spacing.sm}px;
`;

const Subtitle = styled(Typography)`
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: ${marketplaceColors.concrete50};
  letter-spacing: 0.48px;
  margin-top: ${spacing.xxs}px;
`;

export const CategoryTitleSection = ({ title, subtitle }) => {
  if (!(title || subtitle)) return null;

  return (
    <Box marginBottom="lg">
      {title && (
        <Title intent="h1" data-testid="category-title">
          {title}
        </Title>
      )}
      {subtitle && (
        <Subtitle intent="body" data-testid="category-subtitle">
          {subtitle}
        </Subtitle>
      )}
    </Box>
  );
};

CategoryTitleSection.propTypes = {
  title: PT.string,
  subtitle: PT.string,
};
